import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { MAHUB_HOST} from '../env'
const refreshTimeout = 30000;

export default function MasterDashboardBox({ departmentNameID, departmentName }) {
  const auth = useAuth();
  const [points, setPoints] = useState(0);
  const [pointsPercent, setPointsPercent] = useState(0);
  const [operators, setOperators] = useState(0);
  const [shiftLabel, setShiftLabel] = useState("");

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const isFullScreen = params.get("fullscreen") === "true";

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, refreshTimeout);
    return () => clearInterval(interval);
  }, [departmentNameID]);

  const fetchData = () => {
    getNumberOfOperators();
    getShifts();
  };

  const getNumberOfOperators = () => {
    const url = `${MAHUB_HOST}/WorkorderPoints/get-todays-number-of-operators/${departmentNameID}`;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${auth.user?.access_token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Erreur");
        return res.json();
      })
      .then((data) => {
        console.log(data)
        setOperators(data);
        updateSumOfPoints(data);
      })
      .catch(() => setOperators("0"));
  };

  const updateSumOfPoints = (qtyOfOperators) => {
    const url = `${MAHUB_HOST}/WorkorderPoints/get-todays-points/${departmentNameID}`;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${auth.user?.access_token}`,
      },
    })
    .then((res) => {
      if (!res.ok) throw new Error("Erreur");
      return res.json();
    })
    .then((data) => {
      let calculatedPercent = 0;
      if (qtyOfOperators && !isNaN(qtyOfOperators)) {
        calculatedPercent = Math.round((data / (qtyOfOperators * 400)) * 1000) / 10;
      } 
      setPoints(data);
      setPointsPercent(calculatedPercent);
    })
    .catch(() => setPoints(""));
};

  const getShifts = () => {
    const date = new Date();
    let shiftUrl = "";

    if (date.getHours() < 7) {
      shiftUrl = `${MAHUB_HOST}/WorkorderPoints/get-today-evening-shift/${departmentNameID}`;
    } else if (date.getHours() < 15) {
      shiftUrl = `${MAHUB_HOST}/WorkorderPoints/get-todays-morning-shift/${departmentNameID}`;
    } else {
      shiftUrl = `${MAHUB_HOST}/WorkorderPoints/get-todays-evening-shift/${departmentNameID}`;
    }

    fetch(shiftUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${auth.user?.access_token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Erreur");
        return res.json();
      })
      .then((data) => {
        if (data === "06:00:00") setShiftLabel("points depuis 6h");
        else if (data === "07:00:00") setShiftLabel("points depuis 7h");
        else if (data === "23:00:00") setShiftLabel("points depuis 23h");
        else if (data === "00:00:00" && date.getHours() === 23)
          setShiftLabel("points depuis 3h");
        else if (data === "00:00:00") setShiftLabel("points depuis minuit");
        else if (date.getHours() >= 15 && date.getHours() < 23)
          setShiftLabel("points depuis 15h");
        else setShiftLabel("points");
      })
      .catch(() => setShiftLabel("points"));
  };

  return (
    <div style={{ textAlign: "left" }}>
      <div style={{
        fontFamily: "Montserrat, sans-serif",
        textAlign: "center",
        fontWeight: 800,
        color: "#324395",
        fontSize: isFullScreen ? "36px" : "28px",       
        marginBottom: isFullScreen ? "-70px" : "-55px"  
      }}>
        {departmentName}
      </div>
  
      <div className={isFullScreen ? "pointsDesk-full-screen" : "pointsDesk"}>
        <h1>{pointsPercent}%</h1>
  
        <hr className={isFullScreen ? "centralHR-full-screen" : "centralHR"} />
  
        <div className={isFullScreen ? "bottomPointsDesk-full-screen" : "bottomPointsDesk"}>
          <p>{points} {shiftLabel}</p>
          <p>{operators} travailleurs</p>
        </div>
      </div>
    </div>
  );
  
}
